module.exports = __webpack_public_path__ + "f8808087f4274679248d4afe209b52c7.svg";